<template>
	<v-col class="balance-mutation">
		<div class="d-flex justify-space-between">
			<div class="font-size-13 font-weight-bold secondary--text">Repeat Order History</div>
		</div>
		<div class="mt-5">
			<v-row justify="space-between" class="align-center mb-5">
				<v-col cols="12" sm="6" md="4" lg="4" xl="3" class="">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow blue darken-4"  v-if="Object.keys(quotaRO).length > 0">
						<v-row>
							<v-col cols="2" sm="2" md="2" class="pr-0 my-auto text-center">
								<img class="img-fluid filter-white" src="/assets/icon/saldo.png">
							</v-col>
							<v-col cols="10" sm="10" md="10">
								<div class="font-size-12 white--text font-weight-bold">{{ quotaRO.quota  | toCurrencyFormat }}</div>
								<div class="font-size-10 white--text">Repeat Order Quota</div>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col cols="12" sm="6" md="6" lg="6" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Search</div>
							</div>
						</v-btn>
					</div>
				</v-col>
			</v-row>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div v-if="!loading">
					<v-row v-if="historyROList.length > 0">
						<v-col cols="12" class="pt-0">
							<v-data-table hide-default-footer disable-sort :headers="tableHeaders" :items="historyROList" item-key="quota_log_id" class="table-vo table-w-sm-120">
								<template v-slot:[`item.date`]="{ item }">
									{{ item.quota_log_datetime | toDateHour }}
								</template>
								<template v-slot:[`item.quota`]="{ item }">
									<div class="secondary--text font-weight-bold">{{ item.quota_log_value | toCurrencyFormat }}</div>
								</template>
								<template v-slot:[`item.status`]="{ item }">
									<v-chip :color="(item.quota_log_type == 'in') ? 'teal lighten-2' : 'red lighten-2'" class="white--text font-weight-600" small>
										{{ (item.quota_log_type == 'in') ? 'In' : 'Out' }}
									</v-chip>
								</template>
								<template v-slot:[`item.note`]="{ item }">
									{{ item.quota_log_notes }}
								</template>
							</v-data-table>
						</v-col>
					</v-row>
					<div class="mt-3" v-if="historyROList.length == 0">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
									<NoData></NoData>
									<div class="pt-3 text-center cl-secondary">No repeat order history can be displayed</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
					<div v-if="historyROList.length > 0">
						<v-row justify="end">
							<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
								<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historyROPagination.total_page" @input="changePage"></v-pagination>
							</v-col>
							<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
								<div class=" font-size-10">Showing {{ historyROPagination.total_display }} data from {{ historyROPagination.total_data }} data</div>
							</v-col>
							<v-col cols="4" sm="2" md="1">
								<v-select :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="primary" @input="changeLimit"></v-select>
							</v-col>
						</v-row>
					</div>
				</div>
			</v-scroll-x-reverse-transition>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari'

export default {
	components: {
		ModalCari,
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
			tableHeaders: [
				{ text: 'Tanggal', width: '25%', align: 'start', value: 'date' },
				{ text: 'Kuota', width: '25%', align: 'end', value: 'quota' },
				{ text: 'Status', width: '20%', align: 'center', value: 'status' },
				{ text: 'Catatan', width: '30%', align: 'start', value: 'note' },
			]
		}
	},
	computed: {
		...mapState('repeatOrder', ['quotaRO', 'historyROList', 'historyROPagination']),
	},
	methods: {
		...mapActions('repeatOrder', ['getQuotaRO', 'getHistoryRO']),

		getData() {
			this.loading = true
			this.getQuotaRO().then(() => {
        this.getHistoryRO(this.queryString({sort: 'bonus_log_id', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
          this.loading = false
        })
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		showSearch() {
			this.$refs.modalCari.modalShow()
		},
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
			this.$refs.modalCari.reset()
		},
		cari(data) {
			this.params = []

			if (data.date.value)
				this.params.push(data.date)
			if (data.type.value)
				this.params.push(data.type)

			this.getHistoryRO(this.queryString({sort: 'bonus_log_id', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalCari.modalHide()
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Repeat Order History`)
		this.getData()
	}
};
</script>